import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedDate } from 'react-intl'

import MisHeader from '../../Components/MisHeader'

class BattleResume extends React.Component {
  constructor(props) {
    super(props)
  }

  closePopUp() {
    const { removeScreen, removeInfo, getBattle, removeQuestion, setIndividualBattle } = this.props

    removeInfo({
      hits: 0,
      fails: 0,
      question: 1,
    })
    removeScreen('battle_resume_screen')
    removeQuestion(null)
    setIndividualBattle(null)
    getBattle(true)
  }

  checkBattle() {
    const { removeScreen, addScreen } = this.props

    removeScreen('battle_resume_screen')
    addScreen('check_battle_screen')
  }

  render() {
    const { resume, addHowlSound, hideTabs } = this.props
    const fails = resume.wrongAnswers
    const { helpBtn, settingsBtn } = hideTabs || {}

    return (
      <div className="container background background--mina">
        <div className="content">
          <div className="mis">
            <MisHeader helpBtn={helpBtn} settingsBtn={settingsBtn} />

            <div className="mis--challenge__confirmation">
              <h1 className="h1">
                <span className="icon-desafio"> </span>
                <span>
                  <FormattedMessage id="battles.resume" />
                </span>
                <span className="icon-desafio"> </span>
              </h1>
              <div className="mis--challenge__info">
                <div className="title">
                  <FormattedMessage id="battles.completed" />
                </div>
                <div className="mis--boxes">
                  <div className="mis--result">
                    <div className="mis--result__item">
                      <span className="green">{resume.correctAnswers}</span>
                      <span>
                        <FormattedMessage id="battles.hits" />
                      </span>
                    </div>
                    <div className="mis--result__item">
                      <span className="red">{fails}</span>
                      <span>
                        <FormattedMessage id="battles.fails" />
                      </span>
                    </div>
                  </div>
                  <div className="mis--time">
                    <div className="mis--time__item">
                      <FormattedDate
                        value={resume.totalDuration}
                        second="numeric"
                        minute="numeric"
                      />
                      <FormattedMessage id="battles.time" />
                    </div>
                  </div>
                </div>
                <div className="mis--battle__buttons">
                  <div
                    className="btn--shape shape--orange"
                    onClick={() => {
                      this.checkBattle()
                      addHowlSound('button_click')
                    }}
                  >
                    <div className="btn--shape__canvas">
                      <FormattedMessage id="battles.check" />
                    </div>
                  </div>
                  <div
                    className="btn--shape shape--orange"
                    onClick={() => {
                      this.closePopUp()
                      addHowlSound('button_click_icon')
                    }}
                  >
                    <div className="btn--shape__canvas">
                      <FormattedMessage id="battles.continue" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

BattleResume.propTypes = {
  addScreen: PropTypes.func,
  setIndividualBattle: PropTypes.func,
  removeScreen: PropTypes.func,
  removeInfo: PropTypes.func,
  getBattle: PropTypes.func,
  removeQuestion: PropTypes.func,
  resume: PropTypes.object,
  addHowlSound: PropTypes.func,
  hideTabs: PropTypes.object,
}

export default BattleResume
